import React, { useEffect, useState } from "react";
import "../Styles/Employeeapprove.css";
import { useNavigate } from "react-router-dom";
import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaTrash,
} from "react-icons/fa";

import { IoLogoWhatsapp } from "react-icons/io";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function Employeeapprove() {

  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(false);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
  });

  const recordsPerPage = 10;

  /* =========================================
     FETCH EMPLOYEES
  ========================================= */
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {

    try {

      setLoading(true);

      const res = await AdminAPI.getEmployees();

      console.log("FULL API RESPONSE:", res);

      console.log("API DATA:", res.data);

      let apiData = [];

      if (Array.isArray(res.data)) {
        apiData = res.data;
      } else if (Array.isArray(res.data?.data)) {
        apiData = res.data.data;
      } else {
        apiData = [];
      }

      const formatted = apiData.map((emp, index) => {

        console.log("SINGLE EMPLOYEE:", emp);

        /* =========================================
           IMPORTANT
           USE MEMBERSHIP ID FOR APPROVE/REJECT
           Fall back to a stable synthetic id ONLY
           for React's `key` / row identity — never
           for the actual approve/reject API calls.
        ========================================= */
        const membershipId =
          emp?.member?.membership_id ||
          emp?.membership_id ||
          "";

        const rowId =
          membershipId ||
          emp?.details?.employee_id ||
          `row-${index}`;

        return {

          id: rowId,

          membership_id: membershipId,

          employee_id:
            emp?.details?.employee_id || "",

          /* =========================================
             BASIC DETAILS
          ========================================= */
          name:
            emp?.member?.full_name || "",

          designation:
            emp?.details?.designation || "",

          department:
            emp?.details?.department || "",

          organization_name:
            emp?.details?.organization_name || "",

          phone:
            emp?.member?.mobile || "",

          email:
            emp?.member?.email || "",

          official_email:
            emp?.details?.official_email || "",

          gender:
            emp?.member?.gender || "",

          blood_group:
            emp?.member?.blood_group || "",

          dob:
            emp?.member?.dob || "",

          role:
            emp?.member?.role || "",

          state:
            emp?.member?.state || "",

          district:
            emp?.member?.district || "",

          pincode:
            emp?.member?.pincode || "",

          /* =========================================
             STATUS
             Defaults to "pending" whenever the backend
             hasn't sent a status yet — this is what makes
             a freshly registered employee show as Pending.
          ========================================= */
          status:
            (
              emp?.member?.status ||
              emp?.status ||
              "pending"
            ).toLowerCase(),

          /* =========================================
             EXTRA DETAILS
          ========================================= */
          working_location:
            emp?.details?.working_location || "",

          industry:
            emp?.details?.industry || "",

          experience:
            emp?.details?.experience || "",

          company_strength:
            emp?.details?.company_strength || "",

          company_website:
            emp?.details?.company_website || "",

          referral_id:
            emp?.details?.referral_id || "",

          profile_pic:
            emp?.member?.profile_pic || "",

          created_at:
            emp?.member?.created_at || "",

          approved_at:
            emp?.member?.approved_at || "",

          rejected_at:
            emp?.member?.rejected_at || "",

          raw: emp,
        };
      });

      console.log("FORMATTED DATA:", formatted);

      setEmployees(formatted);

    } catch (err) {

      console.error("FETCH ERROR:", err);

      if (err.response) {
        console.log("ERROR RESPONSE:", err.response);
        console.log("ERROR DATA:", err.response.data);
      }

      toast.error("Failed to load employees");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     SEARCH
  ========================================= */
  const filteredEmployees = employees.filter((emp) => {

    const term = searchTerm.toLowerCase();

    return (

      emp.name.toLowerCase().includes(term) ||

      emp.designation.toLowerCase().includes(term) ||

      emp.phone.toLowerCase().includes(term) ||

      emp.status.toLowerCase().includes(term) ||

      emp.organization_name.toLowerCase().includes(term)
    );
  });

  /* =========================================
     PAGINATION
  ========================================= */
  const totalPages =
    Math.ceil(
      filteredEmployees.length / recordsPerPage
    ) || 1;

  const paginatedEmployees =
    filteredEmployees.slice(
      (page - 1) * recordsPerPage,
      page * recordsPerPage
    );

  /* =========================================
     SELECT ALL
  ========================================= */
  const toggleSelectAll = (e) => {

    if (e.target.checked) {

      setSelectedIds(
        paginatedEmployees
          .filter((emp) => emp.membership_id)
          .map((emp) => emp.membership_id)
      );

    } else {

      setSelectedIds([]);
    }
  };

  /* =========================================
     SELECT SINGLE
  ========================================= */
  const toggleSelect = (id) => {

    if (!id) return;

    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  /* =========================================
     CHECK SELECT ALL
  ========================================= */
  const isAllSelected =
    paginatedEmployees.length > 0 &&
    paginatedEmployees
      .filter((emp) => emp.membership_id)
      .every((emp) =>
        selectedIds.includes(emp.membership_id)
      );

  /* =========================================
     UPDATE UI STATUS
  ========================================= */
  const updateStatusUI = (
    membershipIds,
    newStatus
  ) => {

    setEmployees((prev) =>
      prev.map((emp) => {

        if (
          membershipIds.includes(
            emp.membership_id
          )
        ) {

          return {
            ...emp,
            status: newStatus,
          };
        }

        return emp;
      })
    );
  };

  /* =========================================
     APPROVE (BULK - selected checkboxes)
  ========================================= */
  const handleApprove = async () => {

    if (selectedIds.length === 0) {

      toast.warning(
        "Please select employees to approve!"
      );

      return;
    }

    try {

      setLoading(true);

      console.log(
        "APPROVING IDS =>",
        selectedIds
      );

      /* =========================================
         API CALL
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.approveMember(
            membershipId
          )
        )
      );

      /* =========================================
         UPDATE TABLE STATUS
      ========================================= */
      updateStatusUI(
        selectedIds,
        "approved"
      );

      toast.success(
        "Approved successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(
        "APPROVE ERROR =>",
        err
      );

      toast.error("Approval failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     REJECT (BULK - selected checkboxes)
  ========================================= */
  const handleReject = async () => {

    if (selectedIds.length === 0) {

      toast.warning(
        "Please select employees to reject!"
      );

      return;
    }

    try {

      setLoading(true);

      console.log(
        "REJECT IDS =>",
        selectedIds
      );

      /* =========================================
         API CALL
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.rejectMember(
            membershipId
          )
        )
      );

      /* =========================================
         UPDATE TABLE STATUS
      ========================================= */
      updateStatusUI(
        selectedIds,
        "rejected"
      );

      toast.success(
        "Rejected successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(
        "REJECT ERROR =>",
        err
      );

      toast.error("Reject failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     DELETE SELECTED
  ========================================= */
  const handleDeleteSelected = async () => {

    if (selectedIds.length === 0) {

      toast.warning(
        "Select employees to delete!"
      );

      return;
    }

    try {

      setLoading(true);

      await AdminAPI.bulkDeleteMembers(
        selectedIds
      );

      setEmployees((prev) =>
        prev.filter(
          (emp) =>
            !selectedIds.includes(
              emp.membership_id
            )
        )
      );

      toast.success(
        "Deleted successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(err);

      toast.error("Delete failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     DELETE ALL
  ========================================= */
  const handleDeleteAll = async () => {

    try {

      const allIds = employees
        .map((emp) => emp.membership_id)
        .filter(Boolean);

      if (allIds.length === 0) {

        toast.warning(
          "No employees found"
        );

        return;
      }

      setLoading(true);

      await AdminAPI.bulkDeleteMembers(
        allIds
      );

      setEmployees([]);

      setSelectedIds([]);

      toast.success("All deleted!");

    } catch (err) {

      console.error(err);

      toast.error("Delete all failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     SEND MESSAGES
  ========================================= */
  const handleSendMessages = () => {

    if (selectedIds.length === 0) {

      toast.warning(
        "Select employees to send messages!"
      );

      return;
    }

    const channels = [];

    if (sendOptions.email)
      channels.push("Email");

    if (sendOptions.whatsapp)
      channels.push("WhatsApp");

    if (channels.length === 0) {

      toast.warning(
        "Select at least one communication method!"
      );

      return;
    }

    toast.success(
      `Messages sent via ${channels.join(", ")}`
    );
  };

  return (

    <div className="empview-container">

      <ToastContainer
        position="top-center"
        autoClose={2000}
      />

      {/* =========================================
         HEADER
      ========================================= */}
      <div className="empview-header-bar">

        <h2>Employee Approve</h2>

      </div>

      {/* =========================================
         ACTION BAR
      ========================================= */}
      <div className="empview-action-bar">

        <button className="empview-filter-btn">
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">

          <FaSearch />

          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(
                e.target.value
              )
            }
          />

        </div>

        <button
          className="empview-delete-btn"
          onClick={handleDeleteSelected}
        >
          <FaTrash /> Delete Selected
        </button>

        <button
          className="empview-delete-btn"
          onClick={handleDeleteAll}
        >
          <FaTrash /> Delete All
        </button>

      </div>

      {/* =========================================
         TOOLBAR
      ========================================= */}
      <div className="empview-toolbar">

        <label>
          {employees.length} Employee
        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                email: !p.email,
              }))
            }
          />

          <FaEnvelope /> Email

        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.whatsapp}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                whatsapp: !p.whatsapp,
              }))
            }
          />

          <IoLogoWhatsapp /> WhatsApp

        </label>

        <button
          className="empview-send-btn"
          onClick={handleSendMessages}
        >
          Send
        </button>

        <button
          className="empview-download-btn"
          onClick={handleApprove}
          disabled={loading}
        >
          Approve Selected
        </button>

        <button
          className="empview-download-btn"
          onClick={handleReject}
          disabled={loading}
        >
          Reject Selected
        </button>

      </div>

      {/* =========================================
         TABLE
      ========================================= */}
      <div className="empview-table-container">

        <table className="empview-table table table-hover">

          <thead>

            <tr>

              <th>

                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />

              </th>

              <th>Name</th>

              <th>Designation</th>

              <th>Phone</th>

              <th>Status</th>

              <th>Action</th>

            </tr>

          </thead>

          <tbody>

            {paginatedEmployees.length > 0 ? (

              paginatedEmployees.map((emp) => (

                <tr key={emp.id}>

                  <td>

                    <input
                      type="checkbox"
                      checked={selectedIds.includes(
                        emp.membership_id
                      )}
                      disabled={!emp.membership_id}
                      onChange={() =>
                        toggleSelect(
                          emp.membership_id
                        )
                      }
                    />

                  </td>

                  <td>{emp.name}</td>

                  <td>{emp.designation}</td>

                  <td>{emp.phone}</td>

                  <td
                    style={{
                      color:
                        emp.status === "approved"
                          ? "green"
                          : emp.status ===
                            "rejected"
                          ? "red"
                          : "orange",

                      fontWeight: "bold",
                    }}
                  >
                    {emp.status}
                  </td>

                  <td>

                    {/* =========================================
                       ✅ UPDATED — only "View Details" shows here
                       now, for every row regardless of status.
                       Approve/Reject no longer render inline in
                       this table — that action now only happens
                       from the candidate's detail page (navigate
                       below still passes membershipId/employeeData
                       so that page can do the approve/reject call).
                    ========================================= */}

                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate(
                          "/dashboard/EmployeeapproveView",
                          {
                            state: {
                              membershipId:
                                emp.membership_id,

                              employeeData: emp,
                            },
                          }
                        )
                      }
                    >
                      View Details
                    </button>

                  </td>

                </tr>
              ))

            ) : (

              <tr>

                <td
                  colSpan="6"
                  className="empview-no-data"
                >
                  No records found
                </td>

              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* =========================================
         PAGINATION
      ========================================= */}
      <div className="empview-pagination">

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(page - 1)
          }
        >
          Previous
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() =>
            setPage(page + 1)
          }
        >
          Next
        </button>

      </div>

    </div>
  );
}

export default Employeeapprove;